// @ts-check

const buildGroupingLookup = (groupings, lookup) => {
  for (const g of groupings) {
    // for performance, we don't want to create a new object

    lookup[g.id] = g;
    buildGroupingLookup(g.childGroupings, lookup);
  }
  return lookup;
};

export default buildGroupingLookup;
